import axios from 'axios';
import { requestTimeout,messageDuration} from "@/settings";
import {  Message } from "element-ui";
const service = axios.create({
    baseURL:'https://xspeckerapi.hivi.com/api/v1',
    timeout: requestTimeout,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8", 
    },
});

const errorMsg = (message) => {
    return Message({
      message: message,
      type: "error",
      duration: messageDuration,
    });
};

service.interceptors.response.use(
    (response)=>{
        const { data } = response;
        return data;
    },
    (error) => {
        /*网络连接过程异常处理*/
        let { message } = error;
        if (message == "Network Error") {
          message = "后端接口连接异常";
        }
        if (message.includes("timeout")) {
          message = "后端接口请求超时";
        }
        if (message.includes("Request failed with status code")) {
          message = "后端接口" + message.substr(message.length - 3) + "异常";
        }
        errorMsg(message || "后端接口未知异常");
        return Promise.reject(error);
    }
)


export default service;